import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PersianKeyValue} from '../../model/SamanHealthFamilyModels';
import {SelectionDataType} from '../../model/selection-data-type.enum';
import {FormGroup} from '@angular/forms';
import {StaticMethods} from '../../model/GeneralModels';
import {AppSettingsService} from '../../services/app-settings.service';

@Component({
  selector: 'app-radio-button',
  template: `
    <form [formGroup]="Group" *ngIf="Group && type">
      <mat-radio-group [ngSwitch]="type" aria-label="Select an option" formControlName="{{fieldName}}"  (change)="valueChanged($event)">
        <div *ngSwitchCase="2">
          <mat-radio-button *ngFor="let item of list"
                            value="{{item}}">{{settings.translateEnglish(item, translation)}}</mat-radio-button>
        </div>
        <div *ngSwitchCase="0">
          <mat-radio-button *ngFor="let item of list"
                            value="{{item.getValue()}}">
            {{settings.translateEnglish(item.getPersianLabel(), translation)}}
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </form>
  `,
  styles: [`
    mat-radio-button {
      margin-right: 15px;
      margin-left: 15px;
      font-family: iran-sans, serif;
    }
  `]
})
export class RadioButtonComponent implements OnInit, OnChanges {
  @Input() list: any[] | string[] | PersianKeyValue[];
  @Input() Group: FormGroup;
  @Input() fieldName: string;
  @Input() translation: any = {};
  @Input() value: any;
  @Output() OnChange = new EventEmitter();
  type: SelectionDataType = SelectionDataType.stringList;
  label: string;

  constructor(public settings: AppSettingsService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.list.firstChange) {
      if (changes.list.currentValue !== changes.list.previousValue && changes.list.currentValue) {
        this.type = this.setType();
      }
      if (changes.fieldName && changes.fieldName.currentValue && changes.fieldName.currentValue !== changes.field.previousValue) {
        this.label = StaticMethods.getTranslation(this.fieldName);
      } else {
        this.label = 'Select an option';
      }
      if (this.value) {
        switch (this.type) {
          case SelectionDataType.objectList:
            const selectedObject = this.list.find(item => {
              return item.persianLabel === this.value;
            });
            if (selectedObject) {
              this.Group.controls[this.fieldName].patchValue(selectedObject.englishLabel);
            }
            break;
          case SelectionDataType.stringList:
            this.Group.controls[this.fieldName].patchValue(this.value);
            break;
          case SelectionDataType.unknownType:
            break;
        }
        this.valueChanged(this.value);
      }
    }
  }

  setType() {
    if (this.list.length) {
      switch (typeof this.list[0]) {
        case 'object':
          return SelectionDataType.objectList;
        case 'string':
          return SelectionDataType.stringList;
      }
      console.log(this.type);
    } else {
      return SelectionDataType.unknownType;
    }
  }

  valueChanged(event) {
    console.log(event);
    this.OnChange.emit(this.Group.controls[this.fieldName].value);
  }
}
